import { makeStyles } from "@material-ui/core";
import colors from "../../helpers/colorPalette";

const useStyles = makeStyles(theme => ({
    poemListContainer: {
        paddingTop: "60px"
    },
}));

export default useStyles;